import { FormEvent, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { FiMapPin } from 'react-icons/fi';
import { Button } from '../../components/Button';
import { Card } from '../../components/Card';
import { Input } from '../../components/Input';
import { PasswordInput } from '../../components/PasswordInput';
import { loginMotoboy } from '../../api/rastreamento';
import { formatarCelular } from '../../utils/mascaras';

export function LoginMotoboy() {
  const params = useParams();
  const navigate = useNavigate();
  const tenantId = Number(params.tenantId || 0);
  const [celular, setCelular] = useState('');
  const [senha, setSenha] = useState('');
  const [entrando, setEntrando] = useState(false);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setEntrando(true);

    try {
      const resposta = await loginMotoboy(tenantId, celular, senha);
      navigate(`/motoboy/${tenantId}/${resposta.token_rastreamento}`);
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: 'Nao foi possivel entrar',
        text: error.response?.data?.erro || 'Confira seu celular e senha.',
      });
    } finally {
      setEntrando(false);
    }
  }

  return (
    <div className="lizzi-motoboy-auth-page">
      <div className="lizzi-motoboy-auth-shell">
        <div className="lizzi-motoboy-auth-copy">
          <span className="lizzi-auth-kicker">
            <FiMapPin size={14} />
            Motoboy
          </span>
          <h1>Acesse sua rota</h1>
          <p>Entre com celular e senha para receber os pedidos encaminhados e enviar sua localizacao em tempo real.</p>
        </div>

        <Card className="lizzi-motoboy-auth-card">
          <form onSubmit={handleSubmit} className="lizzi-auth-form">
            <Input
              label="Celular"
              value={celular}
              onChange={(event) => setCelular(formatarCelular(event.target.value))}
              maxLength={15}
              placeholder="(00) 00000-0000"
              required
            />

            <PasswordInput label="Senha" value={senha} onChange={(event) => setSenha(event.target.value)} required />

            <Button type="submit" disabled={entrando}>
              {entrando ? 'Entrando...' : 'Entrar no app'}
            </Button>
          </form>
        </Card>
      </div>
    </div>
  );
}
